import { Button } from "antd";
import { useState } from "react";
import OperatorCreate from "../../components/operators/operators.create";
import OperatorList from "../../components/operators/operators.list";
import { useI18n } from "../../i18n/I18nContext";

const OperatorPage = () => {
  const [open, setOpen] = useState(false);
  const { t } = useI18n();

  return (
    <div>
      <Button onClick={() => setOpen(true)} style={{ marginBottom: 16 }}>
        {t("users.create")}
      </Button>
      <OperatorCreate isModalOpen={open} closeModal={() => setOpen(false)} />
      <OperatorList />
    </div>
  );
};

export default OperatorPage;
